import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";

import Layout from "../components/common/layout";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import Div100vh from "react-div-100vh";
import { Div, Text } from "atomize";

import HomeHero from "../components/home/HomeHero";
import HomeSlider from "../components/home/HomeSlider";
import HomeBrandsFooter from "../components/home/HomeBrandsFooter";
import HomeHeroSwiper from "../components/home/HomeHeroSwiper";
import HomeCreatorsList from "../components/home/HomeCreatorsList";
import Footer from "../components/common/Footer";
import HomeStatsSection from "../components/home/HomeStatsSection";
import HomeFooterSection from "../components/home/HomeFooterSection";
import CustomContainer from "../components/common/CustomContainer";
import WebsiteContainer from "../components/common/WebsiteContainer";
import BrandApplicationModal from "../modals/BrandApplicationModal";

const IndexPage = ({ data }) => {
  const [isTransparent, setIsTransparent] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const handleScroll = () => {
    const height = 200;
    if (window.pageYOffset >= height) {
      setIsTransparent(false);
    } else {
      setIsTransparent(true);
    }
  };

  const showBrandApplication = val => {
    setShowModal(val);
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
  });

  const home = data && data.contentfulHome.homeJson;

  const creatorsFirst = home.creatorsList.creators.slice(0, 12);
  const creatorsSecond = home.creatorsList.creators.slice(12, 24);
  const creatorsLast = home.creatorsList.creators.slice(
    24,
    home.creatorsList.creators.length
  );

  // console.log(data.contentfulHome.homeJson);

  return (
    <Layout>
      <SEO seo={data.contentfulHome.seo} url="https://trend.io" />
      <Header
        headerFixed={true}
        isTransparent={isTransparent}
        data={{ contentfulJson: data.headerJson }}
      />
      <Div
        className="home-hero-section"
        m={{ t: { xs: "-57px", lg: "-60px" } }}
      >
        <HomeHeroSwiper hero={home.hero} />
      </Div>
      <Div>
        <WebsiteContainer>
          <CustomContainer>
            <Div className="creators-list-head">
              <Text tag="h2" className="title">
                {home.creatorsList.title}
              </Text>
              <Div className="subtitle">{home.creatorsList.subTitle}</Div>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
        <HomeCreatorsList
          content={creatorsFirst}
          showBrandApplication={val => showBrandApplication(val)}
        />
      </Div>
      <Div>
        <HomeStatsSection content={home.statsSection} />
      </Div>
      <Div>
        <HomeCreatorsList
          content={creatorsSecond}
          showBrandApplication={val => showBrandApplication(val)}
        />
      </Div>
      <Div>
        <HomeFooterSection content={home.actionSection} />
      </Div>
      <Div>
        <HomeCreatorsList
          content={creatorsLast}
          showBrandApplication={val => showBrandApplication(val)}
        />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
      <Div pos="fixed" bottom="0" w="100%" zIndex="100">
        <HomeBrandsFooter />
      </Div>
      <Div id="brandApplicationModal">
        <BrandApplicationModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          modalContent={data.contentfulHome.workWithMeModal}
        />
      </Div>

      {/* <Div100vh>
        <Div h="100%" d="flex" flexDir="column">
          <Header
            headerFixed={true}
            data={{ contentfulJson: data.headerJson }}
          />
          <HomeHero
            title={data.contentfulHome.heroTitle}
            description={data.contentfulHome.heroDescription}
            btnLink={data.contentfulHome.btnLink}
            btnText={data.contentfulHome.btnText}
            btn2Text={data.contentfulHome.btn2Text}
            btn2Link={data.contentfulHome.btn2Link}
          />
          <HomeSlider cards={data.contentfulHome.cards} />

          <HomeBrandsFooter />
        </Div>
      </Div100vh> */}
    </Layout>
  );
};

export const query = graphql`
  query HomePageQuery {
    contentfulHome {
      heroTitle
      heroDescription
      btnLink
      btnText
      btn2Link
      btn2Text
      cards {
        __typename
        ... on ContentfulCaseStudy {
          title
          slug
          companyName
          userName
          userImage {
            file {
              url
            }
            description
          }
          companyLogo {
            file {
              url
            }
            description
          }
          color
        }
        ... on ContentfulBlog {
          id
          title
          thumbnail {
            id
            file {
              url
            }
            description
          }
          slug
          label
        }
        ... on ContentfulContentCardFullVideo {
          image {
            file {
              url
            }
            description
          }
          video {
            file {
              url
            }
            description
          }
        }
        ... on ContentfulContentCardImage {
          title
          media {
            __typename
            ... on ContentfulImage {
              image {
                file {
                  url
                }
                description
              }
            }
          }
          companyLogo {
            file {
              url
            }
            description
          }
          postsCount
          companyName
          piecesCount
          totalImpressions
          totalLikes
          totalComments
          description
          linkUrl
          showRibbon
          ribbonLabel
        }
        ... on ContentfulContentCardVideo {
          title
          media {
            __typename
            ... on ContentfulVideo {
              image {
                file {
                  url
                }
                description
              }
              video {
                file {
                  url
                }
                description
              }
            }
          }
          companyLogo {
            file {
              url
            }
            description
          }
          postsCount
          companyName
          piecesCount
          totalImpressions
          totalLikes
          totalComments
          description
          linkUrl
          showRibbon
          ribbonLabel
        }
      }

      homeJson {
        hero {
          heroTitle
          homeHeroImages
          heroBtnPrimary {
            text
            link
          }
          heroBtnSecondary {
            text
            link
          }
          heroSubText
        }
        creatorsList {
          title
          subTitle
          creators {
            pic
            name
            instagramFollowers
            location
            gallery {
              type
              source
            }
            text
            actionBtn {
              text
              link
            }
            secondaryAction {
              text
              linkText
              link
            }
          }
        }
        statsSection {
          title
          actionBtn {
            text
            link
          }
          creators {
            title
            subTitle
          }
          photos {
            title
            subTitle
          }
          perCreator {
            title
            subTitle
          }
        }
        actionSection {
          btn {
            link
            text
          }
          title
        }
      }

      workWithMeModal {
        json
      }

      seo {
        ...SeoFragment
      }
    }

    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }
  }
`;

export default IndexPage;
